<template>
  <div class="main">
    <OrdersOverviewDeliveredPartially  style="width:100%"/>
  </div>
</template>

<script>
import OrdersOverviewDeliveredPartially from '@/components/OrdersPartially/OrdersOverviewDeliveredPartially.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    OrdersOverviewDeliveredPartially,
  },
  data() {
    return {
      tabIndex: null,
    }
  },
  methods: {
    ...mapActions([]),
  },
}

</script>

  <style>
  .main {
    display: flex;
    gap: 10px;
  }
  </style>
